
import Vuex                     from 'vuex'
import useEmployeesAPI          from '@/composables/useEmployeesAPI'

const helperMethods = {
 
  // these may need to be ['first-name'], ['last-name'], and ['middle-initial']
  makeName(c)  {
       // calculated name string 'first mi last'
      let s = c['first-name']
      s += ' '
      s += (c?.['middle-initial'])?c['middle-initial']+' ':'' 
      s += c['last-name']
      return s; 
  },

  saveUser(user)  {
      const { storeEmployee}  = useEmployeesAPI()

        console.log("Helper-method saveUser (Store) fired")
      try {
        storeEmployee(user)
      }
      catch(e)  {
        console.log("Vues:: Store:: storeEmployee:  error thrown: "+ e.message)
      }  

  },
  deleteContactOnUser (user, index) {
      const { deleteEmployeeContact}  = useEmployeesAPI()

        try {
          deleteEmployeeContact(user, index)
        }
        catch(e)  {
          console.log("Vues:: deleteContact:: updateEmployee:  error thrown: "+ e.message)
        }  
  
  }
}

/*
    LOCAL STORE CONTEXT:
    If the $store.state.user.uuid is valid, it will have a 8-4-4-4-12 hexadecimal pattern
    Set the initiator to '00000000-0000-0000-0000-0000000000'
    This can then be tested on components.    If a component setup() retrieves a state.user object
    and the UUID is zeros, then a refresh has occured and the user must be reloaded into the store.
*/

const store = new  Vuex.Store({
  strict: true,  
  state: {
    user: {
        'uuid':                     "00000000-0000-0000-0000-000000000000",
        'name-concat':            "",
        'first-name':             "",
        'last-name':              "",
        'middle-initial':         "",
        'netid':                  "",
        'ms-object-id':           "",
        'uin':                    "",
        'home-org':               "",
        'eclass-code':            "",
        'title':                  "",
        'address1':               "",
        "address2":               "",
        "city":                   "",
        "state":                  "",
        "postcode":               "",
        "country":                "",
        "mailcode":               "",
        "timezone":               "",
        "req-photo-suppress":     false,
        "college":                null,
        "college-code":           null,
        "department":             null,
        "department-code":        null,
        "division":               null,
        'division-code':          null,

        // the following user properties will be replaced by membership in Entra seurity groups
        'is-sys-admin':           false,
        'is-dept-admin':          false,
        'is-receiver':            false,
        'is-it-support':          false,
        'is-auditor':             false,

        // defines initial screen shown
        'default-role':           "User",
 
        // security refinement
        'allowed-orgs':           [],     
        'contacts':               []
    },
    config: {
        'uuid':                   "00000000-0000-0000-0000-000000000000",        
        'apply-college-code':     null,
        'apply-dept-code':        null,     
        'apply-orgcode':          null, 
        'notice':                 "",          
        'title':                  "University of Illinois Urbana-Champaign",  
        'title-link':             "https://illinois.edu",                  
        'suppress-photos':        false,  
        'suppress-cmdb-data':     false,
        'barcode-type':           "CODE128", 
        'tag-prefix':             "UN",
        'record-created-on':      "" 
    },
    role: {
      "active-role":              ""
    }
  },
  getters: {

    getUser(state)   {
        state.user['name-concat'] =   helperMethods.makeName(state.user)
        return state.user;
    }
    
  },
  mutations: {
    
    setUser (state, employee)  {
        state.user = employee
    },
    updateMailCode(state, code) {
      state.user['mailcode'] = code
    },
    setConfig(state, configSet)  {
        state.config = configSet
    },
    setSysAdmin (state, v)    {
       if(v) state.user['is-sys-admin'] = true  
      else  state.user['is-sys-admin'] = false
    },
    setDeptAdmin (state, v)    {
      if(v) state.user['is-dept-admin'] = true  
      else  state.user['is-dept-admin'] = false
    },  
    setAuditor (state, v)    {
      if(v) state.user['is-auditor'] = true  
      else  state.user['is-auditor'] = false
    },  
    setITSupport (state, v)    {
      if(v) state.user['is-it-support'] = true  
      else  state.user['is-it-support'] = false
    },  
    setReceiver (state, v)    {
      if(v) state.user['is-receiver'] = true  
      else  state.user['is-receiver'] = false
    },  
    setDefaultRole (state, role)    {
      state.user['default-role'] = role  
    },
    setActiveRole (state, role)    {
      state.role['active-role'] = role  
    },

    deleteContact (state, index ) {
        console.log("Store: contact delete mutator fired")
        state.user.contacts.splice(index,1)
    },
    addContact (state, object) {
        console.log("Store: contact add mutator fired")
        state.user.contacts.push(object)
    }
  },
  actions: {

    setUser (context, object) {
        context.commit('setUser', object)
    },
    updateMailCode( context, code) {
        context.commit('updateMailCode', code)
    },
    setConfig (context, object) {
        context.commit('setConfig', object)
    },
    setSysAdmin(context, v) {
      context.commit('setSysAdmin', v)
    },    
    setDeptAdmin(context, v) {
      context.commit('setDeptAdmin', v)
    },
    setAuditor(context, v) {
      context.commit('setAuditor', v)
    },
    setITSupport(context, v) {
      context.commit('setITSupport', v)
    },
    setReceiver(context, v) {
      context.commit('setReceiver', v)
    },
    setDefaultRole(context, role) {
      context.commit('setDefaultRole', role)
    },
    setActiveRole(context, role) {
      context.commit('setActiveRole', role)
    },
    deleteContact (context, idx) {
        // deletes contact on store user
        context.commit( 'deleteContact', idx)
    }, 
    addContact (context, contact) {
        // add contacts to store user
        context.commit('addContact', contact)
    }

  },
  modules: {

  } 
})

export {store}  
